import { KEY } from './keyboard';

export const USING_KEYBOARD = 'using-keyboard';

class Navigation {
  constructor() {
    this.isModeDetectionEnabled = false;
    this.handleMouseDown = undefined;
    this.handleKeyDown = undefined;
  }

  enableModeDetection() {
    if (this.isModeDetectionEnabled) return;
    this.isModeDetectionEnabled = true;

    this.handleMouseDown = () => {
      document.body.classList.remove(USING_KEYBOARD);
    };

    this.handleKeyDown = (e) => {
      if (KEY.isTab(e)) {
        document.body.classList.add(USING_KEYBOARD);
      }
    };

    document.body.addEventListener('mousedown', this.handleMouseDown, true);
    document.body.addEventListener('keydown', this.handleKeyDown, true);
    if (this.surfFrame) {
      try {
        this.surfFrame.contentWindow.addEventListener('mousedown', this.handleMouseDown, true);
        this.surfFrame.contentWindow.addEventListener('keydown', this.handleKeyDown, true);
      } catch (err) {
        console.error(err);
      }
    }
  }

  disableModeDetection() {
    if (!this.isModeDetectionEnabled) return;
    this.isModeDetectionEnabled = false;

    document.body.removeEventListener('mousedown', this.handleMouseDown);
    document.body.removeEventListener('keydown', this.handleKeyDown);
    if (this.surfFrame) {
      try {
        this.surfFrame.contentWindow.removeEventListener('mousedown', this.handleMouseDown, true);
        this.surfFrame.contentWindow.removeEventListener('keydown', this.handleKeyDown, true);
      } catch (err) {
        console.error(err);
      }
    }
  }

  setSurfFrame(surfFrame) {
    this.surfFrame = surfFrame;
  }
}

export default new Navigation();
